// Taken from serialize-json npm library
// @W-14338255@ Allow / since it's harmless with > escaped:
// https://gus.lightning.force.com/lightning/r/ADM_Work__c/a07EE00001cq6y3YAA/view

import { IS_DEVELOPMENT } from '~/modules/config';

// const REGEXP_UNSAFE_FOR_TEXT = /["<>/\u2028\u2029]/g; // also replaces '/' (disabled)
const REGEXP_UNSAFE_FOR_TEXT = /["<>\u2028\u2029]/g;

// Escape a script close tag to ensure we don't accidentally terminate the script section in the middle of a JSON payload
// https://www.man42.net/blog/2016/12/safely-escape-user-data-in-a-script-tag
// https://html.spec.whatwg.org/multipage/scripting.html#restrictions-for-contents-of-script-elements
const REGEXP_UNSAFE_FOR_JSON = /<\/script/gi;

// Mapping of unsafe strings to safe counterparts that can be serialized into HTML documents
const REPLACE_MAP: Record<string, string> = {
    '<': '\\u003C',
    '>': '\\u003E',
    '/': '\\u002F',
    '"': '\\u0022',
    '\u2028': '\\u2028',
    '\u2029': '\\u2029',
    '</script': '\\x3C/script',
};

function replacer(text: string) {
    return REPLACE_MAP[text.toLowerCase()];
}

export function sanitizeText(text: string) {
    return text.replace(REGEXP_UNSAFE_FOR_TEXT, replacer);
}

export function sanitizeJsonText(text: string) {
    return text.replace(REGEXP_UNSAFE_FOR_JSON, replacer);
}

export function sanitizeJson(json: object) {
    // Convert the JSON object to a string, applying indentation if in development environment.
    // In lower environments like development, indentation helps with readability and debugging.
    return sanitizeJsonText(JSON.stringify(json, undefined, IS_DEVELOPMENT ? 2 : undefined));
}
